import React, { useContext } from 'react'
import { FormContext } from '../../FormContext'
  
const StepPersonalInformation: React.FC = () => {
    const context = useContext(FormContext);
  
    if (!context) {
      throw new Error("Step Personal Information must be used within a FormContextProvider");
    }
  
    const { 
        name, 
        setName, 
        email, 
        setEmail, 
        number, 
        setNumber, 
        company,
        setCompany,
        occupation,
        setOccupation,
        service,
        setService,
        source,
        setSource,

        isLoading,
        handleValidation,
        error 
    } = context;

    return (
        <div className='pt-8 p-4 my-auto w-full'>
            <h3 className='text-black text-2xl font-bold'>Let’s Discuss!</h3>
            <p className='text-slate-500 text-base'>Masih bertanya-tanya apa program pelatihan terbaik untuk tim Anda?</p>
            <form action="" onSubmit={handleValidation} className='pt-8'>
                <div className='mb-4'>
                    <div className='flex justify-between items-center'>
                        <label htmlFor="name" className="block text-base font-medium leading-6 text-gray-900">
                            Nama Lengkap
                        </label>
                        {error&&name==='' ? <span className='text-red-500 text-xs'>This field is required</span> : '' }
                    </div>
                    <div>
                        <input
                            onChange={(e) => setName(e.target.value)}
                            value={name}
                            type="text"
                            name="name"
                            id="name"
                            className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-900 sm:text-sm sm:leading-6"
                            placeholder="cth: John Doe"
                        />
                    </div>
                </div>

                <div className='mb-4'>
                    <div className='flex justify-between items-center'>
                        <label htmlFor="email" className="block text-base font-medium leading-6 text-gray-900">
                            Email Professional
                        </label>
                        {error && email === '' ? (
                            <span className='text-red-500 text-xs'>This field is required</span>
                            ) : email !== '' && !email.includes('@') ? (
                            <span className='text-red-500 text-xs'>Invalid Email</span>
                            ) : null}
                    </div>
                    <div>
                        <input
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                            type="email"
                            name="email"
                            id="email"
                            className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-900 sm:text-sm sm:leading-6"
                            placeholder="cth: john.doe@iykra.com"
                        />
                    </div>
                </div>

                <div className='mb-4'>
                    <div className='flex justify-between items-center'>
                        <label htmlFor="number" className="block text-base font-medium leading-6 text-gray-900">
                            Nomor Telepon
                        </label>
                        {error&&number==='' ? <span className='text-red-500 text-xs'>This field is required</span> : '' }
                    </div>
                    <div>
                        <input
                            onChange={(e) => {
                                let value = e.target.value.replace(/\D/g, "");
                                if (value.startsWith("0")) {
                                    value = value.substring(1);
                                }
                                setNumber(value);
                            }}
                            value={number}
                            type="text"
                            name="number"
                            id="number"
                            className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-900 sm:text-sm sm:leading-6"
                            placeholder="cth: 8123456789"
                            maxLength={14}
                        />
                    </div>
                </div>
                <div className='mb-4'>
                    <div className='flex justify-between items-center'>
                        <label htmlFor="company" className="block text-base font-medium leading-6 text-gray-900">
                            Perusahaan
                        </label>
                        {error&&company==='' ? <span className='text-red-500 text-xs'>This field is required</span> : '' }
                    </div>
                    <div>
                        <input
                            onChange={(e) => setCompany(e.target.value)}
                            value={company}
                            type="text"
                            name="company"
                            id="company"
                            className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-900 sm:text-sm sm:leading-6"
                            placeholder="cth: IYKRA"
                        />
                    </div>
                </div>
                <div className='mb-4'>
                    <div className='flex justify-between items-center'>
                        <label htmlFor="company" className="block text-base font-medium leading-6 text-gray-900">
                            Jabatan
                        </label>
                        {error&&occupation==='' ? <span className='text-red-500 text-xs'>This field is required</span> : '' }
                    </div>
                    <div>
                        <input
                            onChange={(e) => setOccupation(e.target.value)}
                            value={occupation}
                            type="text"
                            name="company"
                            id="company"
                            className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-900 sm:text-sm sm:leading-6"
                            placeholder="cth: Data Scientist"
                        />
                    </div>
                </div>

                <div className='mb-4'>
                    <div className='flex justify-between items-center'>
                        <label htmlFor="source" className="block text-base font-medium leading-6 text-gray-900">
                            Servis apa yang dibutuhkan oleh perusahan anda?
                        </label>
                        {error&&service==='' ? <span className='text-red-500 text-xs'>This field is required</span> : '' }
                    </div>
                    <div>
                        <select
                            onChange={(e) => setService(e.target.value)}
                            value={service}
                            name="service"
                            id="service"
                            aria-placeholder="Pilih salah satu"
                            aria-label="Pilih salah satu"
                            aria-required="true"
                            className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-900 sm:text-sm sm:leading-6"
                        >
                            <option value="" hidden>Pilih salah satu</option>
                            <option value="Corporate Training">Corporate Training</option>
                            <option value="Implementasi Proyek">Implementasi Proyek</option>
                            <option value="Kolaborasi Dengan Talenta Kami">Kolaborasi Dengan Talenta Kami</option>
                        </select>
                    </div>
                </div>
                <div className='mb-4'>
                    <div className='flex justify-between items-center'>
                        <label htmlFor="source" className="block text-base font-medium leading-6 text-gray-900">
                            Dari mana Anda mengetahui IYKRA?
                        </label>
                        {error&&source==='' ? <span className='text-red-500 text-xs'>This field is required</span> : '' }
                    </div>
                    <div>
                        <select
                            onChange={(e) => setSource(e.target.value)}
                            value={source}
                            name="source"
                            id="source"
                            aria-placeholder="Pilih salah satu"
                            aria-label="Pilih salah satu"
                            aria-required="true"
                            className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-900 sm:text-sm sm:leading-6"
                        >
                            <option value="" hidden>Pilih salah satu</option>
                            <option value="Google Search">Google Search</option>
                            <option value="LinkedIn InMail">LinkedIn InMail</option>
                            <option value="Media Sosial">Media Sosial</option>
                            <option value="Referral">Referral</option>
                        </select>
                    </div>
                </div>

                <div className='mt-8'> 
                    { isLoading ? (
                        <button type='submit' className='flex float-right py-2 px-8 rounded-md bg-blue-800 hover:bg-blue-700 text-slate-100 text-base disabled cursor-not-allowed' disabled>
                            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4.93 4.93a10 10 0 0114.14 14.14l1.41 1.41a12 12 0 00-16.97-16.97l1.41 1.41z"></path>
                            </svg>
                            Loading...
                        </button>
                    ) : <button type='submit' className='float-right py-2 px-8 rounded-md bg-blue-800 hover:bg-blue-700 text-slate-100 text-base disabled '>Submit</button>}
                </div>
            </form>
        </div>
    );
}

export default StepPersonalInformation